import ScannerEvent from "@/ScannerEvents/ScannerEvent";

export default class MutationEvent extends ScannerEvent {
    constructor(action, fallbackActionName) {
        super();

        this.action = action;
        this.fallbackActionName = fallbackActionName;
    }

    static MatchesType(type) {
        return type === "m";
    }

    static ParseData(jsonData) {
        return new MutationEvent(jsonData.a, jsonData.fa);
    }
}
